module.exports = __webpack_public_path__ + "static/media/industries.fcd82e59.png";